import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { paginationApi } from './paginationApi'

export type PaginationState = AsyncState<number>

export const initialPaginationState = (fetchUrl: string): PaginationState =>
  loadingAsyncState(() => paginationApi(fetchUrl))
